import { useMemo } from 'react';
import { useRutilusQuery } from '@graphql/client/useRutilusQuery';
import { getTrashCollectionBrandLeaderboard } from '@graphql/queries/rutilus/MillionPoundChallenge';
import { LeaderboardRow } from '../components/Leaderboard';

interface IOptions {
  skip?: boolean;
}

export const useTrashCollectionBrandLeaderboard = ({ skip }: IOptions = {}) => {
  const { data, loading } = useRutilusQuery(getTrashCollectionBrandLeaderboard, { skip });

  const brandsRows = useMemo<LeaderboardRow[]>(() => {
    const entries = data?.trashCollectionBrandLeaderboard ?? [];
    return [...entries]
      .sort((a, b) => b.totalWeightInKgs - a.totalWeightInKgs)
      .map((entry, index) => ({
        id: entry.brandName,
        rank: index + 1,
        name: entry.brandName,
        weightInKg: entry.totalWeightInKgs,
      }));
  }, [data]);

  return { brandsRows, isBrandsLoading: loading };
};
